import { CommonEnums } from '../../common.enums';
import { DObj } from './dobj';
import { RepConn } from '../datapoint/repconn';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { DObj_FlatFile_Property } from './dobj_flat_file_property';
import { AttributesUtil } from '../../grids/attributes/attributes.util';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { Attribute } from './attribute';

export class DataObject {
    dObj: DObj;
    attributes: Array<Attribute>;
    dependent_Ids: Array<number>;
    properties: Array<Obj_Db_Property>;
    dObj_FlatFile_Property: DObj_FlatFile_Property;

    fldr_Id: number;
    isDependent: boolean;
    reusableFlag: string;
    lockBy: string;
    mode_Ind: string;
    change_Ind: string;
    unlock_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    isLinkExist: boolean;
    fldrNm: string;
    selectedFlag: string;
    imageUrl: string;
    recExists: boolean;
    fldr_Cd: string;
    viewPrivilegeFlg: string;
    replaceFlg: string;
    action_Nm: string;

    repConn: RepConn;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.attributes = new Array<Attribute>();
        this.dependent_Ids = new Array<number>();
        this.properties = new Array<Obj_Db_Property>();

        this.dObj = new DObj();
        this.repConn = new RepConn();
        this.dObj_FlatFile_Property = new DObj_FlatFile_Property();

        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.lockBy = CommonEnums.defaults.STRING_EMPTY;
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.unlock_Ind = CommonEnums.unlock_Ind.UNSET;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.selectedFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.viewPrivilegeFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.replaceFlg = CommonEnums.defaults.STRING_EMPTY;
        this.action_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.isDependent = false;
        this.isLinkExist = false;
        this.recExists = false;
    }

    static parse(dataObjectTmp: DataObject): DataObject {
        let dataObject: DataObject = new DataObject();
        dataObject.copyFrom(dataObjectTmp);
        return dataObject;
    }

    copyFrom(dataObjectTmp: DataObject): void {
        AttributesUtil.getInstance().copyFrom(this.attributes, dataObjectTmp.attributes);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.properties, dataObjectTmp.properties);

        this.dObj.copyFrom(dataObjectTmp.dObj);
        this.dObj_FlatFile_Property.copyFrom(dataObjectTmp.dObj_FlatFile_Property);
        this.repConn = dataObjectTmp.repConn;

        this.fldr_Id = dataObjectTmp.fldr_Id;
        this.isDependent = dataObjectTmp.isDependent;
        this.reusableFlag = dataObjectTmp.reusableFlag;
        this.lockBy = dataObjectTmp.lockBy;
        this.mode_Ind = dataObjectTmp.mode_Ind;
        this.change_Ind = dataObjectTmp.change_Ind;
        this.unlock_Ind = dataObjectTmp.unlock_Ind;
        this.error_Cd = dataObjectTmp.error_Cd;
        this.error_Msg = dataObjectTmp.error_Msg;
        this.ref_Id = dataObjectTmp.ref_Id;
        this.ref_Cd = dataObjectTmp.ref_Cd;
        this.isLinkExist = dataObjectTmp.isLinkExist;
        this.fldrNm = dataObjectTmp.fldrNm;
        this.selectedFlag = dataObjectTmp.selectedFlag;
        this.imageUrl = dataObjectTmp.imageUrl;
        this.recExists = dataObjectTmp.recExists;
        this.fldr_Cd = dataObjectTmp.fldr_Cd;
        this.viewPrivilegeFlg = dataObjectTmp.viewPrivilegeFlg;
        this.replaceFlg = dataObjectTmp.replaceFlg;
        this.action_Nm = dataObjectTmp.action_Nm;
    }

    copy(): DataObject {
        let dataObjectTmp: DataObject = new DataObject();

        dataObjectTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);
        dataObjectTmp.properties = Obj_Db_PropertiesUtil.getInstance().copy(this.properties);
        dataObjectTmp.dObj_FlatFile_Property = this.dObj_FlatFile_Property.copy();

        dataObjectTmp.repConn = this.repConn;
        dataObjectTmp.fldr_Id = this.fldr_Id;
        dataObjectTmp.isDependent = this.isDependent;
        dataObjectTmp.reusableFlag = this.reusableFlag;
        dataObjectTmp.lockBy = this.lockBy;
        dataObjectTmp.mode_Ind = this.mode_Ind;
        dataObjectTmp.change_Ind = this.change_Ind;
        dataObjectTmp.unlock_Ind = this.unlock_Ind;
        dataObjectTmp.error_Cd = this.error_Cd;
        dataObjectTmp.error_Msg = this.error_Msg;
        dataObjectTmp.ref_Id = this.ref_Id;
        dataObjectTmp.ref_Cd = this.ref_Cd;
        dataObjectTmp.isLinkExist = this.isLinkExist;
        dataObjectTmp.fldrNm = this.fldrNm;
        dataObjectTmp.selectedFlag = this.selectedFlag;
        dataObjectTmp.imageUrl = this.imageUrl;
        dataObjectTmp.recExists = this.recExists;
        dataObjectTmp.fldr_Cd = this.fldr_Cd;
        dataObjectTmp.viewPrivilegeFlg = this.viewPrivilegeFlg;
        dataObjectTmp.replaceFlg = this.replaceFlg;
        dataObjectTmp.action_Nm = this.action_Nm;

        // dataObjectTmp.repConn = ObjectsCache.getInstance().getRepConn(this.repConn.conn.conn_Id, this.repConn);

        return dataObjectTmp;
    }

    compare(dataObjectTmp: DataObject): string {
        let diffString = this.dObj.compare(dataObjectTmp.dObj);
        if (diffString != '') return diffString;

        diffString = this.dObj_FlatFile_Property.compare(dataObjectTmp.dObj_FlatFile_Property);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.attributes, dataObjectTmp.attributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.properties, dataObjectTmp.properties);
        if (diffString != '') return diffString;

        return '';
    }

    getAttribute(attr_Id: number): Attribute {
        for( let i: number = 0; i < this.attributes.length; i++ ) {
            if( this.attributes[i].attr_Id == attr_Id) {
                return this.attributes[i];
            }
        }

        return null;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DataObject [dObj:" + this.dObj.toString() +
            ", attributes:" + AttributesUtil.getInstance().toString(this.attributes) +
            ", dObj_FlatFile_Property:" + this.dObj_FlatFile_Property.toString() +
            ", properties:" + Obj_Db_PropertiesUtil.getInstance().toString(this.properties);

        if (isNotCompare) {
            str += "fldr_Id=" + this.fldr_Id + ", isDependent=" + this.isDependent +
                ", reusableFlag=" + this.reusableFlag + ", lockBy=" + this.lockBy +
                ", mode_Ind =" + this.mode_Ind + ", change_Ind=" + this.change_Ind + ", unlock_Ind=" + this.unlock_Ind +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd + ", isLinkExist=" + this.isLinkExist +
                ", fldrNm=" + this.fldrNm + ", selectedFlag=" + this.selectedFlag +
                ", imageUrl=" + this.imageUrl + ", isRecExists=" + this.recExists + ", fldr_Cd=" + this.fldr_Cd +
                ", viewPrivilegeFlg=" + this.viewPrivilegeFlg + ", replaceFlg=" + this.replaceFlg +
                ", action_Nm =" + this.action_Nm;
        }
        str += "]";

        return str;
    }
}